import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { TranslatorContext } from '@jutro/locale';

import { commonQuoteStyles } from 'gw-capability-quoteandbind-common-react';
import { MockUpUtil } from 'gw-portals-util-js';

import messages from './FarmQuoteInfo.messages';

const PATH_TO_MOCK_DATA = 'quote.farm';

function FarmQuoteInfo(props) {
    const { submissionVM } = props;
    const translator = useContext(TranslatorContext);
    const quoteId = _.get(submissionVM, 'quoteID.value');

    const address = _.get(submissionVM, 'baseData.policyAddress.value');
    const { displayName } = address;

    const isAddressDisplayNameMocked = MockUpUtil.isDisplayNameMocked(
        _.get(submissionVM, 'value'),
        PATH_TO_MOCK_DATA,
        'baseData.policyAddress.displayName',
        'baseData.policyAddress.addressLine1',
        'baseData.policyAddress.city'
    );
    const policyAddressToShowInHeader = isAddressDisplayNameMocked
        ? `${address.state} ${address.postalCode}`
        : displayName;

    return (
        <div className={commonQuoteStyles.quoteInfoBar}>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.farmQuote)}
                </div>
                <div id="contextSubmissionId" className={commonQuoteStyles.infoBlockContent}>
                    {quoteId}
                </div>
            </div>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.location)}
                </div>
                <div id="contextLocation" className={commonQuoteStyles.infoBlockContent}>
                    {policyAddressToShowInHeader}
                </div>
            </div>
        </div>
    );
}

FarmQuoteInfo.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired
};

export default FarmQuoteInfo;
